import {
  DeadlineStickerValue,
  GenericStickerState,
  Hub,
  StickerColor,
  StickerType,
  Tag,
  TimerStickerValue,
  TimetrackerValue
} from 'yougile-model'
import {DeadlineCtl} from '@extensions/sticker/controllers/deadline-ctl'
import {Task} from '@extensions/task'
import {getDeadlineStickerColor} from '../sticker-menu/sticker-menu-deadline/utils'
import {getStateColor} from '../sticker-menu/sticker-menu-string/utils'
import {getTimerColor} from '../sticker-menu/sticker-menu-timer/utils'

interface GetStickerColorProps {
  sticker: Tag
  stickerType: StickerType
  stickerValue?: GenericStickerState
  stickerDefaultValue?: GenericStickerState
  filterValues?: string[]
  location: string
  task?: Hub
  hasTransparentStyle?: boolean
}

export const getStickerColor = ({
  sticker,
  stickerType,
  stickerValue,
  stickerDefaultValue,
  filterValues,
  location,
  task,
  hasTransparentStyle
}: GetStickerColorProps): StickerColor => {
  if (location === 'panel') {
    if (!filterValues?.length || filterValues?.length !== 1) {
      return 'sticker-panel'
    }

    if (['string', 'sprint'].includes(stickerType)) {
      const filterValue = filterValues[0]
      const stickerValue = filterValue && sticker.states.index[filterValue]
      return stickerValue
        ? getStateColor(stickerValue, stickerType)
        : 'sticker-panel'
    }

    return 'sticker-panel'
  }

  if (hasTransparentStyle) {
    return 'sticker-transparent'
  }

  if (stickerType === 'repeat') {
    return 'sticker-blue'
  }

  if (['text', 'numeric'].includes(stickerType)) {
    return stickerDefaultValue ? 'sticker-gray' : 'sticker-white'
  }

  if (stickerType === 'timetracking') {
    const value = stickerValue as TimetrackerValue
    return !value?.plan && !value?.work ? 'sticker-gray' : 'sticker-blue'
  }

  if (stickerType === 'deadline') {
    if (
      !stickerValue &&
      task &&
      DeadlineCtl.getBlockedPoints(task).length > 0
    ) {
      return 'sticker-gray'
    }

    if (!stickerValue) {
      return 'sticker-white'
    }

    const value = stickerValue as DeadlineStickerValue
    const taskStatus = task && Task.getGTDStage(task)
    return taskStatus === 'done'
      ? 'sticker-gray'
      : getDeadlineStickerColor(value)
  }

  if (!stickerValue) {
    return 'sticker-white'
  }

  if (['string', 'sprint'].includes(stickerType)) {
    const value = stickerValue as string
    const stateValue = sticker.states.index[value]
    return stateValue ? getStateColor(stateValue, stickerType) : 'sticker-white'
  }

  if (stickerType === 'timer') {
    const value = stickerValue as TimerStickerValue
    return getTimerColor(value)
  }

  return 'sticker-gray'
}
